import React from 'react';

// PM-editable copy separated from UI
export const dashboardTourCopy = {
  headerTitle: 'Welcome to your Wealth Dashboard',
  headerBody: 'Here is a quick tour of the key insights and where to find them.',
  kpiTitle: 'Key Performance Indicators',
  kpiBody: 'These tiles summarize your net worth, readiness, and more at a glance.',
  netWorthTitle: 'Net Worth Trend',
  netWorthBody: 'Track how your net worth evolves over time. Use it to spot progress.',
  allocationTitle: 'Asset Allocation',
  allocationBody: 'See how your portfolio is distributed across asset classes like Equity, Debt, Real Estate, and Gold.',
  heatmapTitle: 'Expense Heatmap by Type',
  heatmapBody: 'Visualize your expense patterns across categories and identify where your money is going over time.',
};

const Tip = ({ title, body }) => (
  <div>
    <div style={{ fontWeight: 600, color: 'var(--foreground, #111827)' }}>{title}</div>
    <div style={{ marginTop: 6, fontSize: 14, color: 'var(--muted-foreground, #6B7280)' }}>{body}</div>
  </div>
);

export const getDashboardTourSteps = () => [
  {
    target: '[data-tour="dashboard-header"]',
    content: <Tip title={dashboardTourCopy.headerTitle} body={dashboardTourCopy.headerBody} />,
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="dashboard-kpis"]',
    content: <Tip title={dashboardTourCopy.kpiTitle} body={dashboardTourCopy.kpiBody} />,
    placement: 'bottom',
  },
  {
    target: '[data-tour="dashboard-networth"]',
    content: <Tip title={dashboardTourCopy.netWorthTitle} body={dashboardTourCopy.netWorthBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="dashboard-allocation"]',
    content: <Tip title={dashboardTourCopy.allocationTitle} body={dashboardTourCopy.allocationBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="dashboard-heatmap"]',
    content: <Tip title={dashboardTourCopy.heatmapTitle} body={dashboardTourCopy.heatmapBody} />,
    placement: 'top',
  },
];


